export const a11yTabProps = (name: string) => {
  return {
    id: `tab-${name.replaceAll(' ', '')}`,
    'aria-controls': `tabpanel-${name.replaceAll(' ', '')}`,
  };
};

export const a11yTabPanelProps = (name: string) => {
  return {
    id: `tabpanel-${name.replaceAll(' ', '')}`,
    'aria-labelledby': `tab-${name.replaceAll(' ', '')}`,
  };
};
